import { render, staticRenderFns } from "./MoneyDetail.vue?vue&type=template&id=634d6c1b&"
import script from "./MoneyDetail.vue?vue&type=script&lang=js&"
export * from "./MoneyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MoneyDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports